import { combineEpics } from "redux-observable";
import { epicBuyProduct } from "./epics/epicBuyProduct";
import { epicBuyProductsConfirmed } from "./epics/epicBuyProductsConfirmed";
import { epicSellProduct } from "./epics/epicSellProduct";
export var epicTrade = combineEpics(epicSellProduct, epicBuyProduct, epicBuyProductsConfirmed);



//////////////////
// WEBPACK FOOTER
// ./src/features/trade-component/epicTrade.ts
// module id = 2448
// module chunks = 3